import React from "react";
import { Image } from "../../image";
import styles from "./styles.modules.scss";

export const Hero = ({ image }: { image?: ImageSourceSets }) => {
    if (!image) return null;

    return (
        <div className={`hero ${styles.hero}`}>
            <div className={`image ${styles.image}`}>
                <Image sources={image} />
            </div>
        </div>
    );
};
